<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        {
          name: 'BU Page',
          to: {
            name: 'BUPage'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'BUPageEdit',
            params: {
              id: $route.params.id,
            },
            query: {
              section: $route.query.section,
            },
          }
        },
        {
          name: 'Application Detail Edit',
          to: {
            name: 'ApplicationDetailPage',
            params: {
              id: $route.params.id,
            },
            query: {
              section: $route.query.section,
            },
          }
        }
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>編輯 BU Page</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <div class="block mb-5">
      <!-- TechnologyTitle -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5"><h4>Application Title</h4></label>
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="applicationDetail.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="applicationDetail.status"></FormSwitch>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Cover Photo</h4>
          <div class="h5 ink-02-medium--text">
            呈現於BU Page及Overview Page <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="applicationDetail.cover_photo"
            dir="application"></ImgUploader>
        </div>
      </div>
      <!-- Detail Page Title -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5">
          <h4>Detail Page Title</h4>
        </label>
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="applicationDetail.detail_page_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Detail Page Banner</h4>
          <div class="h5 ink-02-medium--text">
            呈現於Detail Page置頂區 <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="applicationDetail.detail_page_banner"
            dir="application"></ImgUploader>
        </div>
      </div>
    </div>

    <div class="page-divider mb-5"></div>

    <!-- content -->
    <div class="d-flex">
      <!-- content head -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Content</h3>
        <div class="h4">
          至少需填寫一組 <br />
          於前台左圖右字、右圖左字交錯排版
        </div>
      </div>
      <div class="flex-grow-1">
        <!-- content body -->
        <div class="block mb-5" v-for="(item, i) in applicationDetail.content" :key="item.id">
          <!-- content -->
          <div
            class="form-item py-5 d-flex align-center justify-lg-space-between"
          >
            <h4>Content</h4>
            <button
              v-if="i > 0"
              class="btn btn-danger square w-32px h-32px"
              @click="deleteItem(i)"
            >
              <v-icon color="white">delete</v-icon>
            </button>
          </div>
          <!-- Title -->
          <label class="form-item d-flex pt-5">
            <h4 class="w-160px mr-5">Title</h4>
            <div class="my-n2 flex-grow-1">
              <v-text-field
                v-model="item.title"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
          <!-- Description -->
          <label class="form-item d-flex pt-5">
            <h4 class="w-160px mr-5">Description</h4>
            <div class="my-n2 flex-grow-1">
              <v-textarea
                v-model="item.description"
                outlined
                dense
              ></v-textarea>
            </div>
          </label>
          <!-- img uploader -->
          <div class="form-item d-flex px-5 py-5">
            <div class="w-180px">
              <h4 class="mb-10px">Visual</h4>
              <div class="h5 ink-02-medium--text">
                建議尺寸：999px * 999px <br />
                檔案大小限制：&lt; 1 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <ImgUploader
                :imageUrl.sync="item.visual"
                dir="application"></ImgUploader>
            </div>
          </div>
        </div>
        <!-- add Content Section -->
        <div class="mt-5 mb-9">
          <button class="btn btn-outlined w-100 justify-start" @click="addItem">
            <v-icon class="primary--text mr-2">add_circle</v-icon>
            <span>添加Content Section</span>
          </button>
        </div>
        <div class="page-actions">
          <v-spacer></v-spacer>
          <button class="btn mr-5" @click="cancelHandler">
            <span>取消</span>
          </button>
          <button class="btn btn-primary" @click="saveHandler">
            <span>儲存</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import { required, maxLength } from '@/validation';

export default {
  data: () => ({
    slugValidation: [
      required,
      maxLength(255),
    ],
  }),
  components: {
    FormSwitch,
    ImgUploader,
    Breadscrumbs,
  },
  computed: {
    ...mapState('bupage', ['bu', 'applicationDetail']),
  },
  methods: {
    ...mapActions('bupage', ['setApplicationDetail']),
    addItem() {
      const template = {
        title: '',
        description: '',
        visual: '',
      };
      this.applicationDetail.content.push(template);
    },
    deleteItem(index) {
      this.applicationDetail.content.splice(index, 1);
    },
    cancelHandler() {
      this.$router.go(-1);
    },
    saveHandler() {
      if (this.bu == null) {
        return;
      }
      this.setApplicationDetail(this.applicationDetail);
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
